export default __webpack_public_path__ + "static/media/POL.0882b3e3.svg";